import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'mobx-react';
import {MemoryRouter} from 'react-router-dom';
import {configure} from "mobx";
import {mobilecheck} from "./utils/Utils";

import ComapFrontend from './ComapFrontend';
import AppStore from './stores/AppStore'

import registerServiceWorker from './registerServiceWorker';

configure({enforceActions: true});

let appStore = new AppStore();

fetch('./appConfig.json')
    .then((res) => res.json())
    .then((data) => {
        let appConfig = data;
        appStore.loadConfig(appConfig);

        if (mobilecheck()) {
            appStore.setIsMobile(true);
            appStore.setDrawer({open: false, active: ''});
        }

        ReactDOM.render((
                <MemoryRouter>
                    <Provider appStore={appStore}>
                        <ComapFrontend standalone appStore={appStore}/>
                    </Provider>
                </MemoryRouter>),
            document.getElementById('root'));


        registerServiceWorker();

    }).catch(error => console.error('Error:', error));



// WEBPACK FOOTER //
// ./src/index.js